import Logo from '../../../assets/images/logo.png';
import Page from '../../../components/Page';
import Components from '../WelcomeScreen/styles';

export default function ThankYouScreen() {
  return (
    <Page showHeader={false}>
      <Components.Wrapper>
        <Components.Container>
          <Components.Banner>
            <Components.Logo>
              <img src={Logo} alt="advantage solutions" />
            </Components.Logo>
          </Components.Banner>
          <Components.Hero>
            <Components.HeadlineContainer>
              <Components.Title>Thank you!</Components.Title>
              <Components.Subheadline>your submission is complete!</Components.Subheadline>
            </Components.HeadlineContainer>
            <Components.Description>
              <p>
                Our team will now process your completed form – this can take anywhere from two to five business days.
              </p>
              <p>
                If you have any questions in the meantime, please reach out to your Advantage contact. We look forward
                to working with you!
              </p>
            </Components.Description>
          </Components.Hero>
        </Components.Container>
      </Components.Wrapper>
    </Page>
  );
}
